<template>
    <div>
        <div class="mb-3">
            <pc-label
                class="h4"
                v-bind:label="paymentFailedDialogHeader" />
        </div>
        <div class="mb-3">
            <span> {{ paymentFailedErrorMessage1 }}&nbsp; </span>
            <span class="fw-bold"> {{ paymentFailedErrorMessage2_emphasized }} </span>
        </div>
        <div>
            <span class="fw-bold"> {{ paymentFailedMessageReturnedLabel }}&nbsp; </span>
            <span class="fst-italic"> {{ failureMessage }} </span>
        </div>
        <div class="mb-3">
            <span class="fw-bold"> {{ paymentFailedReferenceNumberLabel }}&nbsp; </span>
            <span> {{ referenceNumberDisplay }} </span>
        </div>
        <div>
            {{ paymentFailedInstructions }}
        </div>
    </div>
</template>

<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/paymentusDialog.i18n";

    export default {
        props: {
            failureMessage: { type: String, required: true },
            referenceNumber: { type: String, required: true }
        },
        computed: {
            referenceNumberDisplay() {
                return this.referenceNumber || this.paymentFailedDefaultReferenceNumber;
            },
            // Localization
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        }
    };
</script>
